module["exports"] = [
  "#{street_name}#{building_number}號"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_TW/address/street_address.js
// module id = 1849
// module chunks = 0